import { Button, Accordion, Span } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { t } from "i18next";
import { AddAttributeValuesAction } from "./add-action/AddAttributeValuesAction";
import { AddHighestPriorityTreatmentAction } from "./add-action/AddHighestPriorityTreatmentAction";
import { AddTreatmentWhenSuggestedAction } from "./add-action/AddTreatmentWhenSuggestedAction";
import { CraForecastChangeType } from "../../../../../project/models/CraForecastScenario";
import { useStores } from "../../../../../shared/stores/RootStore";
import { CustomDialog } from "../../../../../shared/views/CustomDialog";

interface Props {
  onClose: () => void;
}
const AddCraForecastActionModalBase: React.FC<Props> = ({ onClose }) => {
  const { filterStore } = useStores();

  return (
    <CustomDialog
      size="xl"
      onClose={onClose}
      header={t(`map:forecast.addActionModal.header`)}
      footer={
        <Button colorPalette="primary" variant="ghost" onClick={onClose}>
          {t(`shared:close`)}
        </Button>
      }
    >
      <Accordion.Root collapsible>
        <Item actionCode={CraForecastChangeType.HighestPriorityTreatment}>
          <AddHighestPriorityTreatmentAction
            onClose={onClose}
            filteredDistance={filterStore.filteredCraDistance}
            filteredNodes={filterStore.filteredNodes}
          />
        </Item>
        <Item actionCode={CraForecastChangeType.TreatmentWhenSuggested}>
          <AddTreatmentWhenSuggestedAction
            onClose={onClose}
            filteredDistance={filterStore.filteredCraDistance}
            filteredNodes={filterStore.filteredNodes}
          />
        </Item>
        <Item actionCode={CraForecastChangeType.AttributeValues}>
          <AddAttributeValuesAction
            onClose={onClose}
            filteredDistance={filterStore.filteredCraDistance}
            filteredNodes={filterStore.filteredNodes}
          />
        </Item>
      </Accordion.Root>
    </CustomDialog>
  );
};

export const AddCraForecastActionModal = observer(AddCraForecastActionModalBase);

interface ItemProps {
  actionCode: CraForecastChangeType;
  children: React.ReactNode;
}
const Item: React.FC<ItemProps> = ({ actionCode, children }) => {
  return (
    <Accordion.Item value={actionCode}>
      <Accordion.ItemTrigger>
        <Span flex="1">{t(`map:forecast.${actionCode}.accordionHeader`)}</Span>
        <Accordion.ItemIndicator />
      </Accordion.ItemTrigger>
      <Accordion.ItemContent>
        <Accordion.ItemBody>{children}</Accordion.ItemBody>
      </Accordion.ItemContent>
    </Accordion.Item>
  );
};
